import { createFileRoute } from "@tanstack/react-router";

import type { PromoUsageBucketKind } from "@/features/promos/api";
import { isUsageBucket } from "@/features/promos/usageLib";

// Bộ lọc phân tích nằm trên URL: from/to "YYYY-MM-DD", bucket hour|day|week|
// month|quarter|year, branch = mã cơ sở. Thiếu khoá → máy chủ lấy cửa sổ mặc
// định (validFrom → hôm nay, mốc theo độ dài kỳ), rồi vọng lại để điền vào ô.
type PromoDetailSearch = {
  from?: string | undefined;
  to?: string | undefined;
  bucket?: PromoUsageBucketKind | undefined;
  branch?: string | undefined;
  brand?: string | undefined;
};

export const Route = createFileRoute("/_app/promos/$promoId")({
  validateSearch: (search: Record<string, unknown>): PromoDetailSearch => ({
    from: typeof search.from === "string" ? search.from : undefined,
    to: typeof search.to === "string" ? search.to : undefined,
    bucket: isUsageBucket(search.bucket) ? search.bucket : undefined,
    branch: typeof search.branch === "string" ? search.branch : undefined,
    brand: typeof search.brand === "string" ? search.brand : undefined,
  }),
});
